import { render } from "./CRMWhatsappContactDialog.vue?vue&type=template&id=aed643b2&scoped=true"
import script from "./CRMWhatsappContactDialog.vue?vue&type=script&lang=js"
export * from "./CRMWhatsappContactDialog.vue?vue&type=script&lang=js"

import "./CRMWhatsappContactDialog.vue?vue&type=style&index=0&id=aed643b2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aed643b2"]])

export default __exports__